/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Property } from './Property';
import {
    PropertyFromJSON,
    PropertyFromJSONTyped,
    PropertyToJSON,
    PropertyToJSONTyped,
} from './Property';
import type { Link } from './Link';
import {
    LinkFromJSON,
    LinkFromJSONTyped,
    LinkToJSON,
    LinkToJSONTyped,
} from './Link';

/**
 * 
 * @export
 * @interface ResponsibleParty
 */
export interface ResponsibleParty {
    /**
     * 
     * @type {string}
     * @memberof ResponsibleParty
     */
    tenantId?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponsibleParty
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponsibleParty
     */
    roleId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponsibleParty
     */
    partyUuids?: Array<string>;
    /**
     * 
     * @type {Array<Property>}
     * @memberof ResponsibleParty
     */
    props?: Array<Property>;
    /**
     * 
     * @type {Array<Link>}
     * @memberof ResponsibleParty
     */
    links?: Array<Link>;
    /**
     * 
     * @type {string}
     * @memberof ResponsibleParty
     */
    remarks?: string;
}

/**
 * Check if a given object implements the ResponsibleParty interface.
 */
export function instanceOfResponsibleParty(value: object): value is ResponsibleParty {
    return true;
}

export function ResponsiblePartyFromJSON(json: any): ResponsibleParty {
    return ResponsiblePartyFromJSONTyped(json, false);
}

export function ResponsiblePartyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsibleParty {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'roleId': json['roleId'] == null ? undefined : json['roleId'],
        'partyUuids': json['partyUuids'] == null ? undefined : json['partyUuids'],
        'props': json['props'] == null ? undefined : ((json['props'] as Array<any>).map(PropertyFromJSON)),
        'links': json['links'] == null ? undefined : ((json['links'] as Array<any>).map(LinkFromJSON)),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function ResponsiblePartyToJSON(json: any): ResponsibleParty {
    return ResponsiblePartyToJSONTyped(json, false);
}

export function ResponsiblePartyToJSONTyped(value?: ResponsibleParty | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'roleId': value['roleId'],
        'partyUuids': value['partyUuids'],
        'props': value['props'] == null ? undefined : ((value['props'] as Array<any>).map(PropertyToJSON)),
        'links': value['links'] == null ? undefined : ((value['links'] as Array<any>).map(LinkToJSON)),
        'remarks': value['remarks'],
    };
}

